import { Component, OnInit, ViewChild } from "@angular/core";
import { OrganizationService } from "src/app/services/organization/organization.service";
import { PopupMessageService } from "src/app/services/popup-message/popup-message.service";
import { InitializePopupComponent } from "../../components/initialize-popup/initialize-popup.component";
import { AppSetting } from "src/app/backend/app-setting";
import { Router } from "@angular/router";

@Component({
  selector: "app-main-page",
  templateUrl: "./main-page.component.html",
  styleUrls: ["./main-page.component.scss"],
})
export class MainPageComponent implements OnInit {
  @ViewChild("init") init!: InitializePopupComponent;
  constructor(
    private organizationService: OrganizationService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getOrganizationSetting();
  }

  public getOrganizationSetting(): void {
    this.organizationService.getOrganizationSetting().subscribe({
      next: (value) => {
        if (value == null) this.init.show();
      },
      error: (value) => {
        localStorage.removeItem(AppSetting.tokenKey);
        localStorage.removeItem(AppSetting.roleKey);

        this.router.navigate(["/login"]);
      },
    });
  }
}
